<template>
  <div v-if="!hidden" class="container-fixed">
    <el-breadcrumb class="app-breadcrumb" separator=">">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item,index) in levelList" v-if="item.meta.title" :key="index">
          <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
          <router-link v-else :to="item.redirect||item.path">{{ item.meta.title }}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>

export default {
  data() {
    return {
      levelList: null,
      hidden: false
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {

      const matched = this.$route.matched
      const lastMatched = matched.slice(-1)[0]

      this.hidden = !!lastMatched.meta.hideBreadcrumb

      this.levelList = [
        { path: '/', meta: { title: '首页' } },
        ...matched.filter(item => item.name)
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.app-breadcrumb.el-breadcrumb {
  padding: 20px 0;
  a,
  span {
    font-variant: tabular-nums;
    line-height: 1.5;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    color: #000000;
    font-size: 14px;
    font-weight: normal;
  }
  span {
    color: #000000;
  }
  /deep/.el-breadcrumb__separator {
    margin: 0 8px;
    color: #000000;
    font-weight: normal;
  }
}

</style>
